import React, { useState, useEffect, useRef, useCallback } from 'react';
import { AdsCampaignDisclaimers } from '@bingads-webui-campaign-react/ads-campaign-disclaimers';
import { withCustomValidation } from '@bingads-webui-react/validation';

export const getAssociatedDisclaimer = (campaignId, repository, perfMarker = null) => {
  if (campaignId) {
    if (perfMarker) {
      perfMarker.willInit();
    }

    return repository.association.findAll({
      where: {
        campaignId,
      },
    }).then((disclaimerdata) => {
      if (perfMarker) {
        perfMarker.done();
      }

      if (disclaimerdata && disclaimerdata.length > 0) {
        return disclaimerdata[0];
      }
      return null;
    });
  }
  return Promise.resolve(null);
}

const DisclaimerExtensionInternal = (props) => {
  const {
    className,
    updateValidation,
    campaignId,
    repository,
    validationProps,
    ...rest
  } = props;

  const displayPlusDisclaimerRef = useRef(null);
  const { data } = validationProps || {};
  const { DisclaimerAdsEnabled, associatedDisclaimer } = data || {};

  const onDataChange = useCallback(() => {
    const result = displayPlusDisclaimerRef.current.getValues();
    const error = displayPlusDisclaimerRef.current.validateAndWarn();
    // If no disclaimer is associated, update the change to the outside
    if (!result.AdExtensionAssociations || result.AdExtensionAssociations.length === 0) {
      result.AdExtensionAssociations = null;
    }
    updateValidation(error ? [error] : [], result);
  }, [updateValidation]);

  const [disclaimerAdsEnabled, setDisClaimerAdsEnabled] = useState(DisclaimerAdsEnabled);

  useEffect(() => {
    setDisClaimerAdsEnabled(DisclaimerAdsEnabled);
  }, [DisclaimerAdsEnabled]);

  const onDisclaimerCheckboxChange = (value) => {
    setDisClaimerAdsEnabled(value);
  };

  return (
    <div className={className}>
      <AdsCampaignDisclaimers
        ref={displayPlusDisclaimerRef}
        campaignId={campaignId}
        repository={repository}
        selectedDisclaimer={associatedDisclaimer}
        DisclaimerAdsEnabled={disclaimerAdsEnabled}
        onDataChange={onDataChange}
        onDisclaimerCheckboxChange={onDisclaimerCheckboxChange}
        isForNew
        {...rest}
      />
    </div>
  );
};

export const ValidatedDisclaimerExtension = withCustomValidation(DisclaimerExtensionInternal);

